import React, { Fragment } from 'react';
import classNames from 'classnames';

import map from 'lodash/map';

import FocusTrap from 'focus-trap-react';

import {
  GRID_TAXONOMY_FILTER_TYPE_RADIO,
  GRID_TAXONOMY_FILTER_TYPE_CHECKBOX,
  GRID_TAXONOMY_FILTER_TYPE_DROPDOWN
} from 'grid_taxonomy.js';

import CheckboxTagsRenderer from './grid_section_filters.checkbox_renderer.jsx';
import RadioTagsRenderer from './grid_section_filters.radio_renderer.jsx';
import DropdownTagsRenderer from './grid_section_filters.dropdown_renderer.jsx';

import Link from 'zoomforth_component_lib/basic_link.jsx';
import Button from 'zoomforth_component_lib/btn_basic.jsx';
import { OpacityTransition } from 'zoomforth_component_lib/transitions.jsx';
import { FilterIcon, RefreshIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const GridSectionFiltersUi_ViewerVersion1 = ({
  categories,
  canFiltersBeApplied,
  filterType,
  filtersWidth,
  filterToggleText,
  innerMargin,
  innerWrapperMargin,
  shouldShowFiltersSelector,
  selectedTagIdsByCategoryId,
  onCheckboxChange,
  onRadioChange,
  onDropdownChange,
  onApplyFiltersClick,
  onShouldShowFilterSelectorChange,
  onResetClick
})=> (
  <Fragment>

    {
      shouldShowFiltersSelector &&
        <div
          className="fullscreen-filter-background-cover"
          onClick={()=> {
            onShouldShowFilterSelectorChange(false);
          }}
        />
    }

    <div className="grid-section-filters" style={{ width: filtersWidth }}>
      <div className="grid-section-filters-inner-wrapper" style={{ margin: innerWrapperMargin }}>
        <div
          className={classNames('grid-section-filters-inner', {
            active: shouldShowFiltersSelector
          })}
          style={{ margin: innerMargin }}
        >
          <div className="grid-section-filters-toggle">
            <div className="grid-section-filters-toggle-label">
              { filterToggleText }
            </div>
            <div
              className="grid-section-filters-toggle-trigger"
              onClick={()=> {
                onShouldShowFilterSelectorChange(!shouldShowFiltersSelector);
              }}
            >
              <FilterIcon />
            </div>
          </div>

          <OpacityTransition>
            {
              shouldShowFiltersSelector &&
                <div className="grid-section-filters-categories">

                  <div className="grid-section-filters-actions">
                    <div className="grid-section-filters-actions-inner">
                      <Link onClick={onResetClick}>
                        <RefreshIcon /> Reset
                      </Link>
                    </div>
                  </div>

                  {
                    map(categories, (category)=> (
                      filterType === GRID_TAXONOMY_FILTER_TYPE_CHECKBOX ?

                        <CheckboxTagsRenderer
                          key={category.id}
                          categoryId={category.id}
                          categoryLabel={category.label}
                          tags={category.tags}
                          selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                          onChange={onCheckboxChange}
                        />

                      : filterType === GRID_TAXONOMY_FILTER_TYPE_RADIO ?

                        <RadioTagsRenderer
                          key={category.id}
                          categoryId={category.id}
                          categoryLabel={category.label}
                          tags={category.tags}
                          selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                          onChange={onRadioChange}
                        />

                      : filterType === GRID_TAXONOMY_FILTER_TYPE_DROPDOWN ?

                        <DropdownTagsRenderer
                          key={category.id}
                          categoryId={category.id}
                          categoryLabel={category.label}
                          tags={category.tags}
                          selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                          onChange={onDropdownChange}
                        />

                      :

                        null // this shouldn't actually happen
                    ))
                  }

                  <div className="grid-section-filters-actions">
                    <div className="grid-section-filters-actions-inner">
                      <Link
                        onClick={()=> {
                          onShouldShowFilterSelectorChange(false);
                        }}
                      >
                        Cancel
                      </Link>

                      <Button
                        primary
                        disabled={!canFiltersBeApplied}
                        disabledReason={!canFiltersBeApplied ? 'Filters are disabled in this view' : null}
                        onClick={onApplyFiltersClick}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </div>
            }
          </OpacityTransition>
        </div>
      </div>
    </div>
  </Fragment>
);

const GridSectionFiltersUi_ViewerVersion2 = ({
  categories,
  canFiltersBeApplied,
  filterType,
  filtersWidth,
  filterToggleText,
  innerMargin,
  innerWrapperMargin,
  shouldShowFiltersSelector,
  selectedTagIdsByCategoryId,
  onCheckboxChange,
  onRadioChange,
  onDropdownChange,
  onApplyFiltersClick,
  onShouldShowFilterSelectorChange,
  onResetClick
})=> (
  <Fragment>

    {
      shouldShowFiltersSelector &&
        <div
          className="fullscreen-filter-background-cover"
          onClick={()=> {
            onShouldShowFilterSelectorChange(false);
          }}
        />
    }

    <div className="grid-section-filters" style={{ width: filtersWidth }}>
      <div className="grid-section-filters-inner-wrapper" style={{ margin: innerWrapperMargin }}>
        <div
          className={classNames('grid-section-filters-inner', {
            active: shouldShowFiltersSelector
          })}
          style={{ margin: innerMargin }}
        >
          <div className="grid-section-filters-toggle">
            <div className="grid-section-filters-toggle-label">
              { filterToggleText }
            </div>

            <button
              role="button"
              className="grid-section-filters-toggle-trigger"
              onClick={()=> {
                onShouldShowFilterSelectorChange(!shouldShowFiltersSelector);
              }}
            >
              <VisuallyHiddenSpan>
                Filter
              </VisuallyHiddenSpan>
              <FilterIcon />
            </button>
          </div>

          <OpacityTransition>
            {
              shouldShowFiltersSelector &&
                <FocusTrap focusTrapOptions={{ allowOutsideClick: true }}>
                  <div className="grid-section-filters-categories">

                    <div className="grid-section-filters-actions">
                      <div className="grid-section-filters-actions-inner">
                        <Button className="reset-button" onClick={onResetClick}>
                          <RefreshIcon /> Reset
                        </Button>
                      </div>
                    </div>

                    {
                      map(categories, (category)=> (
                        filterType === GRID_TAXONOMY_FILTER_TYPE_CHECKBOX ?

                          <CheckboxTagsRenderer
                            key={category.id}
                            categoryId={category.id}
                            categoryLabel={category.label}
                            tags={category.tags}
                            selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                            onChange={onCheckboxChange}
                          />

                        : filterType === GRID_TAXONOMY_FILTER_TYPE_RADIO ?

                          <RadioTagsRenderer
                            key={category.id}
                            categoryId={category.id}
                            categoryLabel={category.label}
                            tags={category.tags}
                            selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                            onChange={onRadioChange}
                          />

                        : filterType === GRID_TAXONOMY_FILTER_TYPE_DROPDOWN ?

                          <DropdownTagsRenderer
                            key={category.id}
                            categoryId={category.id}
                            categoryLabel={category.label}
                            tags={category.tags}
                            selectedTagIds={selectedTagIdsByCategoryId[category.id] || []}
                            onChange={onDropdownChange}
                          />

                        :

                          null // this shouldn't actually happen
                      ))
                    }

                    <div className="grid-section-filters-actions">
                      <div className="grid-section-filters-actions-inner">
                        <Button
                          className="cancel-button"
                          onClick={()=> {
                            onShouldShowFilterSelectorChange(false);
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          primary
                          disabled={!canFiltersBeApplied}
                          disabledReason={!canFiltersBeApplied ? 'Filters are disabled in this view' : null}
                          onClick={onApplyFiltersClick}
                        >
                          Apply
                        </Button>
                      </div>
                    </div>
                  </div>
                </FocusTrap>
            }
          </OpacityTransition>
        </div>
      </div>
    </div>
  </Fragment>
);

const GridSectionFiltersUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <GridSectionFiltersUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <GridSectionFiltersUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default GridSectionFiltersUi;
